module.exports = __webpack_public_path__ + "3fd422e9ee9cbfa1a791999d380b1967.svg";